<template>
    <div  class="product-detaile" style="/*display: table-cell;*/vertical-align: middle;">
        <!-- ============= 顶部背景图 ============= -->
        <!--div :style="'margin: 0 auto;background: rgba(0, 0, 0, 0) url(\'web/bk/'+name+'.png\') repeat scroll 0% 0% / 100%;'">
            <!--img src="../../assets/images/product/vector.png" style="height: 505px;width: 1300px;margin: 0 auto;min-height:400px;display: block"-->
            <!--img :src="'web/detaile/'+img_name+'.png'" style="height: 505px;width: 1300px;margin: 0 auto;min-height:400px;display: block">
        </div-->

        <!-- ============= 内容相关 ============= -->
        <div class="detaile-p">
            <div class="detaile-p-div">{{pro.pro_name}}</div>
            <div style="float: right;font-size: 25px;margin-top: 20px;">
                {{type_tree.type_par_name}}→{{type_tree.type_name}}
            </div>
            <div class="detaile-p-title"> Basic product information </div>
            <div class="detaile-p-content" id="pro_basic" v-html="pro.pro_basic"></div>
        </div>

        <div class="cut-off-rule"></div>

        <!-- ============= 产品特性介绍 ============= -->
        <div class="detaile-feature">
            <div class="feature-div"> Product features </div>

            <div class="detaile-feature-text" :class="{disActive:featuresText==1 , active:featuresText==2}" :style="{'border-right': featuresText==2?'1px solid rgb(177, 177, 177)':''}">
              <div id='introduce' v-html="pro.pro_introduce">
              </div>
            </div>
            <!--div class="detaile-feature-divider" v-if="featuresText==2"></div-->
            <div class="detaile-feature-text" :class="{disActive:featuresText==1 , active:featuresText==2}"  v-if="featuresText===2">
                <div id='introduce_2' v-html="pro.pro_introduce_2">
                </div>
            </div>
        </div>

        <div class="cut-off-rule"></div>

        <!-- ============= 产品特相关资料 ============= -->
        <div class="detaile-link">
            <div class="link-title">
                <img src="../../assets/images/product/chanpin.png"/>
                <div class="title"> Product documents </div>
            </div>
            <div class="link-options">
                <div class="options" v-for="item in productDatumList">
                    <a href="#" class="link-a">{{item.tool_en_name}}</a>
                </div>
            </div>
        </div>

        <div class="related-resource">
            <div class="detaile-resource">
                <div class="resource-header">
                    <div class="header-title"> Documents </div>
                    <div class="header-select">
                        <el-select no-data-text="No Data" placeholder="Select" v-model="resource" style="line-height: 0px" @change="changeTab(resource)">
                            <el-option
                                    v-for="item in resourceList"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                    class="select-tab"
                            ><a :href="'#'+item">{{item}}</a></el-option>
                        </el-select>
                    </div>
                </div>

                <div v-if="index!='bad'" class="product-table" :id=item[0].tool_type v-for="(item, index) in productStandardList">
                    <div class="table-title">
                        {{index}}
                    </div>
                    <el-table
                            :data="item"
                            border
                            class="table-content">
                        <el-table-column prop="tool_name" label="Name" width="240" align="center"></el-table-column>
                        <el-table-column prop="tool_num" label="Document No." width="240" align="center"></el-table-column>
                        <el-table-column prop="tool_msg" label="Describe" width="480" align="left"></el-table-column>
                        <el-table-column prop="tool_time" label="Update time" align="center"></el-table-column>
                        <el-table-column prop="tool_edit" label="Versions" align="center"></el-table-column>
                        <el-table-column label="Download" align="center">
                            <template slot-scope="scope">
                              <i v-if="scope.row.tool_new_name!='' && scope.row.tool_new_name!=null" style="font-size:38px;line-height:normal;cursor: pointer;" class="iconfont icon-RAR" @click="downloadMarkOne(scope.row)"></i>
                              <i v-if="scope.row.tool_new_pdf_name!='' && scope.row.tool_new_pdf_name!=null" style="font-size:38px;line-height:normal;cursor: pointer;" class="iconfont icon-PDF1" @click="downloadMarkTwo(scope.row)"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-else style="padding-bottom: 50px;">
                    <div class="table-title">
                        {{item.name}}
                    </div>
                    <div style="width: 100%;height: 50px;background-color: white;">
                        <div style="padding: 16px 0px 0px 18px;">{{item.value}}</div>
                    </div>
                </div>

            </div>
        </div>

        <!--div style="position:relative;text-align: center;height: 500px">
            <img src="../../assets/images/product/beijingtu.png" style="width: 100%;height: 100%;display: block">
            <div class="detaile-chip">
                <ul>
                    <li v-for="item in proGoodList">
                        <img src="../../assets/images/product/xinpian1.png">
                        <div class="big-title">{{item.pro_name}}</div>
                        <div class="small-title">{{item.pro_name}}</div>
                    </li>
                </ul>
            </div>
        </div-->
    </div>
</template>
<script>
    import api from '@/http/request'
    export default {
        data() {
            return {
                featuresText:2, // 特性文本 1/2
                resource:'', // 相关资料
                pro: {}, //
                fileGoodList: [], // 推荐工具
                productStandardList: [], // 表格文档列表
                productDatumList: [], // 产品相关资料列表
                proGoodList: [], // 推荐产品列表
                resourceList: [],
                type_tree: {},
                img_name: {},//图片
                name: {},//图片
                
            }
        },

        mounted: function () {
            this.listPage();
            this.img_name='ban'+Math.floor(Math.random()*10+1);
            this.name='bk'+Math.floor(Math.random()*10+1);
        },

        methods: {
            listPage() {
                // 获取参数type_id的值
                let url = location.href  // 查询当前url
                /*let pro_id = url.slice(url.indexOf("pro_id=")+7)
                if(pro_id.indexOf("&") !== -1){
                    pro_id = pro_id.slice(0, pro_id.indexOf("&"))
                }*/
                let pro_id=this.get_get_val('pro_id');
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/pro_all?english=1&pro_id='+pro_id,
                }).then((response) =>{ // 这里使用了ES6的语法
                    let _this = this
                    _this.pro = response.data.pro
                    _this.type_tree = response.data.type_tree
                    let file = Object.keys(response.data.file).map(function (e) { return response.data.file[e]})
                    for (let i = 0; i < file.length ; i++) {
                        if(file[i].length>0){
                          _this.productStandardList.push(file[i])
                          _this.resourceList.push(file[i][0].tool_type)
                        }
                    }
                    
                    _this.productStandardList=response.data.file;
                    
                    let reg = new RegExp("'", "g"); // g,表示全部替换
                    if(_this.pro.pro_basic){
                      //document.getElementById('pro_basic').innerHTML = eval("'" + _this.pro.pro_basic.replace(reg, '"') + "'")
                      //document.getElementById('introduce').innerHTML = eval("'" + _this.pro.pro_introduce.replace(reg, '"') + "'")
                      if(_this.pro.pro_introduce_2 && _this.pro.pro_introduce_2!='""'){
                        //document.getElementById('introduce_2').innerHTML = eval("'" + _this.pro.pro_introduce_2.replace(reg, '"') + "'")
                      }else {
                        _this.featuresText = 1
                      }
                    }else {
                      _this.featuresText = 1
                    }
                    _this.productDatumList = Object.keys(response.data.file_good).map(function (e) { return response.data.file_good[e]})
                    _this.proGoodList = Object.keys(response.data.pro_good).map(function (e) { return response.data.pro_good[e]})
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            changeTab(val) {
                let anchor = this.$el.querySelector('#tab')
                console.log('anchor',anchor)
                document.documentElement.scrollTop = anchor.offsetTop
                console.log('adsf')
            },
            // 下载
            downloadMarkOne: function (row) {
                location.href = '/api/pre/json_go/file_xz?tool_id='+row.tool_id+'&type=1'
            },
            downloadMarkTwo: function (row) {
                location.href = '/api/pre/json_go/file_xz?tool_id='+row.tool_id+'&type=2'
            },
            get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
        }
    }
</script>

<style >
  .product-detaile .detaile-p { /*min-height: 360px;*/width:1300px; margin: 20px auto;}
  .product-detaile .detaile-p-div {background:url('../../assets/images/product/kuang.png') no-repeat; background-size:100% 64px;height:64px;font-size:48px;padding: 0 40px 0 20px;color:#ffffff;display: inline-block; }
  .product-detaile .detaile-btn {width:350px;display: inline-block;float: right; line-height: 64px}
  .detaile-btn .btn {line-height: 40px;display: inline-block;text-align: center;border-radius: 5px;}
  .detaile-btn .is-active {background: #fff;color: #000;border: 1px solid #666;width: 100px;}
  .detaile-btn .active {background: #4a90e2;color: #ffffff;border: 1px solid #4a90e2;width: 100px;}

  .detaile-p .detaile-p-title {padding-left: 30px;font-size:28px;font-weight:bold;color:#333333;line-height:50px;margin-top: 30px}
  .detaile-p .detaile-p-content {text-indent:2em;padding: 10px 30px;font-size:20px;font-weight:100;color:#666666;}

  .product-detaile .detaile-p > p { margin: 0 auto;width: 800px;margin-top: 30px }
  .product-detaile .detaile-chip {width: 100%;height:100%;position: absolute;top: 0}
  .product-detaile .detaile-chip > img { margin-left: 90px }
  .product-detaile .detaile-chip > ul {width: 1300px;margin: 0 auto;}
  .product-detaile .detaile-chip > ul > li { list-style:none;display: inline-block;margin:90px 3px;width: 400px;height: 300px;background: #FFFFFF;border-radius: 7px;}
  .product-detaile .detaile-chip > ul > li  img {margin: 40px 0 10px 0;}
  .detaile-chip .big-title {font-size:48px;color:#333333;line-height:58px;}
  .detaile-chip .small-title {font-size:23px;color:#333333;line-height:35px;}
  .product-detaile .feature-title { color: #918f95 }
  .product-detaile .detaile-link .link-a { color: rgba(22,121,236,1);text-decoration:none }
  .product-detaile .el-divider--horizontal {height: 1px;margin: 0;background: rgba(74,144,226,1);width: 1200px;}

  .product-detaile .detaile-feature {min-height: 400px;width:1300px;margin: 20px auto;overflow: hidden;}
  .product-detaile .feature-div { text-align: left;font-size:28px;font-weight:bold;color:#333333;line-height:70px;}
  .product-detaile .detaile-feature-text {display: inline-block;margin:10px;/*min-height: 600px*/}
  .product-detaile .detaile-feature-divider {display: inline-block;width: 1px;height: 400px;background: #D2D2D2;margin: 80px 5px;float:left;}
  .detaile-feature .disActive {width: 1000px;margin: 10px 150px; padding-left: 20%;}
  .detaile-feature .active {width: 600px;padding: 0 10px;float: left;}

  .product-detaile .detaile-link {width: 1300px;margin: 10px auto;overflow: hidden;}
  .detaile-link .link-title{display:inline-block;width:400px;}
  .link-title img{width: 80px;height:80px;margin-left: 160px;}
  .link-title .title{width: 400px;text-align: center;font-size:24px;color:#333333;line-height:30px;}
  .detaile-link .link-options{display:inline-block;width: 900px;float:right;}
  .link-options .options{display:inline-block;width: 440px;font-size:24px;line-height:65px;}
  .options:hover {text-decoration:underline;}

  .related-resource {width:100%;background-color: rgba(246,246,246,1); }
  .product-detaile .detaile-resource {width:1300px;margin:0 auto; }
  .detaile-resource .resource-header {display: inline-block;width: 100%;}
  .resource-header .header-title {font-size:48px;color:#333333;line-height:150px;display:inline-block;}
  .resource-header .header-select {line-height:150px;display:inline-block;float:right;}
  .select-tab {padding: 0;}
  .select-tab a {width: 100%;height:100%;display:inline-block; color: #606266;padding-left: 20px}

  .detaile-resource .product-table{width: 100%;padding-bottom: 50px;}
  .product-detaile .table-title { background-color: #EFF5FF;width: 100%;height:60px;line-height: 60px;text-align: center;font-size:24px;color:#333333;border-bottom: 2px solid #4A90E2;}
  .product-detaile .table-content {text-align: center; }
  .table-content .has-gutter div {border-right: 1px solid #EBEEF5;font-size:18px;color:#333333;font-weight: 400;line-height: 40px;}
  .table-content .el-table__row .is-center {border-right: 1px solid #EBEEF5;font-weight:100;font-size:15px;color:#000;padding: 3px 0;}
    /* 分割线 */
  .cut-off-rule {height: 3px;background-color:#dedbdb;}
</style>



// WEBPACK FOOTER //
// src/pages/product/detaile.vue